<template>
  <TheSections :is-random-stars="isRandomStars" />
</template>

<script>
import TheSections from '@/components/Hub/Sections/TheSections.vue'

export default {
  name: 'HubSectionsPage',

  components: { TheSections },

  computed: {
    isRandomStars() {
      return localStorage.getItem('tiktok') === 'true'
    }
  }
}
</script>
